import { render } from "./NoDeviceSetupAlert.vue?vue&type=template&id=3b61e9e7&scoped=true"
import script from "./NoDeviceSetupAlert.vue?vue&type=script&lang=js"
export * from "./NoDeviceSetupAlert.vue?vue&type=script&lang=js"

import "./NoDeviceSetupAlert.vue?vue&type=style&index=0&id=3b61e9e7&scoped=true&lang=css"

import exportComponent from "/home/forge/staging.virtualcp.app/releases/20260928150148/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b61e9e7"]])

export default __exports__